// src/modules/app-views/_apps/appsindico/unitProfiles/pages/Init/index.jsx
// *******************************************************************************
// UNIT PROFILES INIT
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useEffect } from 'react';
import { Table } from 'antd';
import { useListContext } from 'components/core/ListProvider';
import useZustand from 'hooks/useZustand';
import appService from 'services/appService';
import { nameColumn, roomsColumn, areaColumn } from './components/tableColumns';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const UnitProfilesInit = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const {
    data,
    loading,
    tableKey,
    pagination,
    handleTableChanges,
    rowSelection,
    buildTableColumns,
    availableTableColumns,
    buildNumberLineColumn,
    buildDocumentCodeColumn,
    buildUpdatedAtColumn,
    buildActionsButtonColumn,
    buildColumnProps,
    query,
    tableComponents,
    hiddenColumns,
    isEditingTable,
    TableFeatures,
  } = useListContext();

  const storedListSettings = useZustand('module', 'listSettings');
  const storedLanguage = useZustand('theme', 'language');

  // Serialize sort and search for stable dependencies
  const sortKey = JSON.stringify(query?.sort || []);
  const searchKey = JSON.stringify(query?.search || {});

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  const isMobile = appService.isMobile();

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // Rebuild columns when sort or settings change
  useEffect(() => {
    buildTableColumns?.([
      buildNumberLineColumn(),

      buildDocumentCodeColumn(),

      nameColumn(buildColumnProps, { title: 'name' }),

      roomsColumn(buildColumnProps, { width: 80 }),

      areaColumn(buildColumnProps, { width: 100 }),

      buildUpdatedAtColumn(),

      buildActionsButtonColumn({
        view: false,
        fitInDropDownMenu: ['archive', 'remove'],
      }),
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    storedListSettings?.showNumberOfLine,
    sortKey,
    searchKey,
    storedLanguage,
    hiddenColumns,
    isEditingTable,
    query?.drawer?.folder,
  ]);

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <>
      <TableFeatures />

      <Table
        key={tableKey}
        scroll={{ x: 'max-content' }}
        bordered
        rowKey="_id"
        size={isMobile ? 'small' : 'large'}
        columns={availableTableColumns}
        dataSource={data || []}
        pagination={pagination}
        className="with-checkbox"
        loading={loading}
        onChange={handleTableChanges}
        rowSelection={rowSelection}
        components={tableComponents}
      />
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default UnitProfilesInit;
